export default {
  functional: true,
  name: 'tableLabel',
  model: {
    prop: 'value',
    event: 'input'
  },
  props: ['value', 'tabs'],
  render: function(h, context) {
    console.log(context);
    console.log(this);
    return (<div>
      {
        context.props.tabs.map(item=>{
          return <span onClick={_=>tabClick(item)}>{item}</span>
        })
      }
    </div>)
  },
  methods: {
    tabClick(item) {

    }
  }
}

function tabClick (item) {
  console.log(item)
}